var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-4"},[_c('Subscribe',{attrs:{"show-coupon":"","country-code":_vm.countryCode,"email":_vm.email},on:{"completed":_vm.completed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }